import { createRouter, createWebHashHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import type { App } from 'vue'
import { Layout } from '@/utils/routerHelper'
import { useI18n } from '@/hooks/web/useI18n'

const { t } = useI18n()

export const constantRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/',
    component: Layout,
    redirect: '/sms',
    name: 'Root',
    meta: {
      hidden: true
    }
  },
  {
    path: '/redirect',
    component: Layout,
    name: 'Redirect',
    children: [
      {
        path: '/redirect/:path(.*)',
        name: 'Redirectt',
        component: () => import('@/views/Redirect/Redirect.vue'),
        meta: {}
      }
    ],
    meta: {
      hidden: true,
      noTagsView: true
    }
  },
  {
    path: '/login',
    component: () => import('@/views/Login/Login.vue'),
    name: 'Login',
    meta: {
      hidden: true,
      title: t('router.login'),
      noTagsView: true
    }
  },
  {
    path: '/logout',
    component: () => import('@/views/Login/Logout.vue'),
    name: 'Logout',
    meta: {
      hidden: true,
      title: t('router.logout'),
      noTagsView: true
    }
  },
  {
    path: '/404',
    component: () => import('@/views/Error/404.vue'),
    name: 'NoFind',
    meta: {
      hidden: true,
      title: '404',
      noTagsView: true
    }
  }
]

export const asyncRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/store',
    component: Layout,
    redirect: '/store/myStore',
    name: 'Store',
    meta: {
      title: t('store.myStore'),
      icon: 'ep:house',
      owPermission: 'admin-edit-merchant'
    },
    children: [
      {
        path: 'myStore',
        name: 'My Store',
        component: () => import('@/views/Store/MyStore.vue'),
        meta: {
          title: t('store.myStore'),
          icon: 'ep:house',
          owPermission: 'admin-edit-merchant'
        }
      }
    ]
  },
  {
    path: '/storebanner',
    component: Layout,
    name: 'StoreBanner',
    redirect: '/storebanner/list',
    meta: {
      title: t('router.storeBanner'),
      owPermission: 'admin-banner'
    },
    children: [
      {
        path: 'list',
        name: 'Store Banners',
        component: () => import('@/views/StoreBanner/StoreBanner.vue'),
        meta: {
          title: t('router.storeBanner'),
          icon: 'ep:picture',
          owPermission: 'admin-banner'
        }
      }
    ]
  },
  {
    path: '/discount',
    component: Layout,
    redirect: '/discount/index',
    name: 'Discount',
    meta: {
      title: t('discount.title'),
      icon: 'ep:ticket',
      owPermission: 'admin-coupon-list'
    },
    children: [
      {
        path: 'index',
        name: 'Discount Index',
        component: () => import('@/views/MultiDiscount/MultiDiscount.vue'),
        meta: {
          title: t('discount.title'),
          icon: 'ep:ticket',
          owPermission: 'admin-coupon-list'
        }
      }
    ]
  },
  {
    path: '/sms',
    component: Layout,
    redirect: '/sms/overview',
    name: 'SMS',
    meta: {
      title: t('router.smsManagement'),
      icon: 'ep:iphone'
    },
    children: [
      {
        path: 'overview',
        name: 'SMS Overview',
        component: () => import('@/views/Sms/Overview.vue'),
        meta: {
          title: t('router.smsOverview'),
          owPermission: 'admin-template'
        }
      },
      {
        path: 'group',
        name: 'SMS Group',
        component: () => import('@/views/Sms/GroupManagement.vue'),
        meta: {
          title: t('router.smsGroup'),
          owPermission: 'admin-template'
        }
      }
    ]
  },
  {
    path: '/sms',
    component: Layout,
    redirect: '/sms/mgr',
    name: 'SMS Admin',
    meta: {
      title: t('router.smsManagement'),
      icon: 'ep:iphone',
      owPermission: 'super'
    },
    children: [
      {
        path: 'mgr',
        name: 'SMS Admin MGR',
        component: () => import('@/views/Sms/Admin.vue'),
        meta: {
          title: t('router.smsManagement'),
          owPermission: 'super',
          icon: 'ep:iphone'
        }
      }
    ]
  },
  {
    path: '/merchant',
    component: Layout,
    redirect: '/merchant/mgr',
    name: 'Merchant Admin',
    meta: {
      title: t('router.merchantSettings'),
      icon: 'ep:setting',
      owPermission: 'super'
    },
    children: [
      {
        path: 'mgr',
        name: 'Merchant Admin MGR',
        component: () => import('@/views/MerchantSettings/Admin.vue'),
        meta: {
          title: t('router.merchantSettings'),
          owPermission: 'super',
          icon: 'ep:setting'
        }
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    redirect: '/user/mgr',
    name: 'User Admin',
    meta: {
      title: t('router.userManagement'),
      icon: 'ep:user',
      owPermission: 'super'
    },
    children: [
      {
        path: 'mgr',
        name: 'User Admin MGR',
        component: () => import('@/views/User/Admin.vue'),
        meta: {
          title: t('router.userManagement'),
          owPermission: 'super',
          icon: 'ep:user'
        }
      }
    ]
  },
  {
    path: '/vipbenefit',
    component: Layout,
    name: 'VipBenefit',
    redirect: '/vipbenefit/list',
    meta: {
      title: t('router.vipbenefit'),
      owPermission: 'admin-vip-cards'
    },
    children: [
      {
        path: 'list',
        name: 'VIP Benefits',
        component: () => import('@/views/VipCard/VipBenefit.vue'),
        meta: {
          title: t('router.vipbenefit'),
          icon: 'ep:ticket',
          owPermission: 'admin-vip-cards'
        }
      }
    ]
  },
  {
    path: '/vipcard',
    component: Layout,
    name: 'VipCard',
    redirect: '/vipcard/list',
    meta: {
      title: t('router.vipcard'),
      owPermission: 'admin-vip-cards'
    },
    children: [
      {
        path: 'list',
        name: 'VIP Cards',
        component: () => import('@/views/VipCard/VipCard.vue'),
        meta: {
          title: t('router.vipcard'),
          icon: 'ep:postcard',
          owPermission: 'admin-vip-cards'
        }
      }
    ]
  },
  {
    path: '/vip',
    component: Layout,
    name: 'Vip',
    redirect: '/vip/list',
    meta: {
      title: t('router.vip'),
      owPermission: 'admin-vip-card-search'
    },
    children: [
      {
        path: 'list',
        name: 'VIP Members',
        component: () => import('@/views/VipMember/VipMember.vue'),
        meta: {
          title: t('router.vip'),
          icon: 'ep:odometer',
          owPermission: 'admin-vip-card-search'
        }
      }
    ]
  },
  {
    path: '/affiliate',
    component: Layout,
    name: 'Affiliate',
    redirect: '/affiliate/list',
    meta: {
      title: t('router.affiliate'),
      owPermission: 'admin-referal'
    },
    children: [
      {
        path: 'list',
        name: 'Affiliate Management',
        component: () => import('@/views/Affiliate/Affiliate.vue'),
        meta: {
          title: t('router.affiliate'),
          icon: 'ep:full-screen',
          owPermission: 'admin-referal'
        }
      }
    ]
  },
  {
    path: '/userrole',
    component: Layout,
    name: 'Users & Roles',
    redirect: '/userrole/index',
    meta: {
      title: t('userrole.title'),
      icon: 'ep:avatar',
      owPermission: 'or admin-staff-list admin-role-list'
    },
    children: [
      {
        path: 'index',
        name: 'Users & Roles Index',
        component: () => import('@/views/Userrole/Users.vue'),
        meta: {
          title: t('userrole.title'),
          icon: 'ep:avatar',
          owPermission: 'or admin-staff-list admin-role-list'
        }
      }
    ]
  },
  {
    path: '/support',
    component: Layout,
    redirect: '/support/index',
    name: 'Support',
    meta: {
      title: t('support.title'),
      hidden: true,
      breadcrumb: true
    },
    children: [
      {
        path: 'index',
        name: 'Support Information',
        component: () => import('@/views/Support/Support.vue'),
        meta: {
          title: t('support.title'),
          hidden: true,
          breadcrumb: true
        }
      }
    ]
  },
  {
    path: '/personal',
    component: Layout,
    redirect: '/personal/index',
    name: 'Personal',
    meta: {
      title: t('personal.title'),
      hidden: true
    },
    children: [
      {
        path: 'index',
        name: 'Personal Information',
        component: () => import('@/views/Personal/Personal.vue'),
        meta: {
          title: t('personal.title'),
          hidden: true
        }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  strict: true,
  routes: constantRouterMap as RouteRecordRaw[],
  scrollBehavior: () => ({ left: 0, top: 0 })
})

export const resetRouter = (): void => {
  const resetWhiteNameList = ['Redirect', 'Login', 'Logout', 'NoFind', 'Root']
  router.getRoutes().forEach((route) => {
    const { name } = route
    if (name && !resetWhiteNameList.includes(name as string)) {
      router.hasRoute(name) && router.removeRoute(name)
    }
  })
}

export const setupRouter = (app: App<Element>) => {
  app.use(router)
}

export default router
